module.exports = __webpack_public_path__ + "img/02_noff_close_L1.f8bb3158.svg";